<template>
  <el-row>
    <el-row v-if="gateData.length"
            :gutter="10"
            class="gate-main">
      <el-col v-for="(item, index) in gateData"
              :key="index"
              :span="2"
              :xs="4"
              :sm="3">
        <el-card class="mb-15 alignCenter gate-item"
                 shadow="hover">
          <el-tooltip class="item"
                      effect="dark"
                      :content="item.name"
                      placement="top">
            <p class="gate-title">{{item.name}}</p>
          </el-tooltip>
          <el-tag style="width: 100%"
                  :type="Number(item.online) === 1 ? 'success' : 'danger'">{{Number(item.online) === 1 ? '在线' : '离线'}}</el-tag>
        </el-card>
      </el-col>
    </el-row>
    <el-card shadow="never">
      <el-row class="dormitory-main"
              :gutter="15">
        <el-col class="building-main"
                :span="3"
                :sm="3"
                :xs="12">
          <p class="item-title">楼宇机构</p>
          <div class="building-item"
               :class="getBuildingClass(item, index)"
               v-for="(item, index) in dormitoryData"
               :key="index"
               :title="item.name"
               @click="changeBuilding(item, index)">
            <i class="el-icon-office-building mr-5"></i>
            <span>{{item.name}}</span>
            <p :title="item.no + '/' + item.yes">
              （ <span class="txt-red">{{item.no}}</span> / <span class="txt-green">{{item.yes}}</span> ）</p>
          </div>
        </el-col>
        <el-col :span="2"
                :sm="3"
                :xs="12">
          <p class="item-title">楼层</p>
          <div class="floor-item"
               v-for="(item, index) in floorData"
               :key="index"
               :class="getFloorClass(item, index)"
               @click="changeFloor(item, index)">
            <p :title="item.name"><i class="el-icon-location-information mr-5"></i>{{item.name}}</p>
            <p :title="item.no + '/' + item.yes">
              （ <span class="txt-red">{{item.no}}</span> / <span class="txt-green">{{item.yes}}</span> ）</p>
          </div>
        </el-col>
        <el-col :span="19"
                :sm="18"
                :xs="24">
          <p class="item-title">设备监控</p>
          <el-row :gutter="10">
            <el-col :span="3"
                    :sm="4"
                    :xs="4"
                    v-for="(item, index) in roomData"
                    :key="index">
              <el-tooltip class="item"
                          effect="dark"
                          :content="item.name + '/' + (Number(item.online) === 1 ? '在线' : '离线') + '/' + (Number(item.door_open) === 0 ? '关' : '开') + '/' +
                          (Number(item.electricity) === 100 ? '电量充足' : '电量告警')+'/'+ item.last_time"
                          placement="top">
                <div class="room-item alignCenter"
                     :class="item.online === Number(item.online) === 1 ? 'bgno' : 'bgyes'">
                  <p>{{item.name}}</p>
                  <p :class="Number(item.door_open) === 0 ? 'txt-green' : 'txt-red'">{{Number(item.door_open) === 0 ? '关' : '开'}}</p>
                  <p :class="Number(item.electricity) === 100 ? 'txt-green' : 'txt-red'">{{Number(item.electricity) === 100 ? '电量充足' : '电量告警'}}</p>
                  <p>
                    {{item.last_time.substring(0,10)}}<br>
                    {{item.last_time.substring(10,item.last_time.length)}}<br>
                  </p>
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
export default {
  data() {
    return {
      url: fetch.getWsUrl,
      // 网关
      gateSocket: null,
      gateData: [],
      gateTimer: null,
      // 设备
      lockSocket: null,
      dormitoryData: [],
      floorData: [],
      roomData: [],
      peopleData: [],
      lockTimer: null,
      activeIndex: 0,
      floorActive: 0
    }
  },
  computed: {
    getBuildingClass() {
      return function (data, index) {
        let activeClass = this.activeIndex === index ? 'active' : ''
        let bgClass = data.yes !== Number(data.yes) + Number(data.no) ? 'bgno' : 'bgyes'
        return activeClass + ' ' + bgClass
      }
    },
    getFloorClass() {
      return function (data, index) {
        let activeClass = this.floorActive === index ? 'active' : ''
        let bgClass = data.yes !== Number(data.yes) + Number(data.no) ? 'bgno' : 'bgyes'
        return activeClass + ' ' + bgClass
      }
    }
  },
  created() {
    this.initWebSocket('lock')
    this.initWebSocket('gate')
  },
  beforeDestroy() {
    this.websocketclose()
  },
  methods: {
    initWebSocket(type) {
      if (type === 'lock') {
        this.lockSocket = new WebSocket('ws://' + this.url)
        this.lockSocket.onopen = (e) => {
          this.websocketonopen(e, type)
        }
        this.lockSocket.onerror = (e) => {
          this.websocketonerror(e, type)
        }
        this.lockSocket.onmessage = (e) => {
          this.websocketonmessage(e, type)
        }
        this.lockSocket.onclose = (e) => {
          this.websocketclose(e, type)
        }
      } else {
        this.gateSocket = new WebSocket('ws://' + this.url)
        this.gateSocket.onopen = (e) => {
          this.websocketonopen(e, type)
        }
        this.gateSocket.onerror = (e) => {
          this.websocketonerror(e, type)
        }
        this.gateSocket.onmessage = (e) => {
          this.websocketonmessage(e, type)
        }
        this.gateSocket.onclose = (e) => {
          this.websocketclose(e, type)
        }
      }
      window.onbeforeunload = (e) => {
        this.websocketclose(e, type)
      }
    },
    websocketonopen(e, type) {
      if (type === 'lock') {
        this.lockSocket.send('lock')
        this.lockTimer = setInterval(() => {
          this.lockSocket.send('lock')
        }, 10000)
      } else {
        this.gateSocket.send('gate')
        this.gateTimer = setInterval(() => {
          this.gateSocket.send('gate')
        }, 10000)
      }
    },
    websocketonerror(e, type) {
      if (type === 'lock') {
        if (this.lockTimer) {
          clearInterval(this.lockTimer)
        }
      } else {
        if (this.gateTimer) {
          clearInterval(this.gateTimer)
        }
      }
      this.$message.error('WebSocket连接发生错误')
    },
    websocketonmessage(e, type) {
      let data = JSON.parse(e.data)
      if (type === 'lock') {
        this.dormitoryData = data.data
        if (data.data) {
          let tmpData = []
          let tmpIndex = ''
          if (this.activeIndex) {
            tmpData = data.data[this.activeIndex]
            tmpIndex = this.activeIndex
          } else {
            let kaysArr = Object.keys(data.data)
            tmpData = data.data[kaysArr[0]]
            tmpIndex = kaysArr[0]
          }
          this.changeBuilding(tmpData, tmpIndex)
        }
      } else {
        this.gateData = data.data
      }
    },
    websocketclose(type) {
      if (type === 'lock') {
        clearInterval(this.lockTimer)
        if (this.lockSocket) {
          this.lockSocket.close()
        }
      } else {
        clearInterval(this.gateTimer)
        if (this.gateSocket) {
          this.gateSocket.close()
        }
      }
    },
    changeBuilding(data, index) {
      this.activeIndex = Number(index)
      this.floorData = data.child
      let tmpData = []
      let tmpIndex = ''
      if (this.floorActive) {
        tmpData = data.child[this.floorActive]
        tmpIndex = this.floorActive
      } else {
        let floorKeysArr = Object.keys(data.child)
        tmpData = data.child[floorKeysArr[0]]
        tmpIndex = floorKeysArr[0]
      }
      this.changeFloor(tmpData, tmpIndex)
    },
    changeFloor(data, index) {
      this.floorActive = Number(index)
      this.roomData = data.child
    }
  }
}
</script>

<style lang="less" scoped>
.gate-main {
  height: 120px;
  overflow-y: auto;
  .gate-item {
    line-height: 20px;
    font-size: 14px;
    .gate-title {
      width: 100%;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.dormitory-main {
  line-height: 20px;
  font-size: 14px;
  .building-main {
    .building-item {
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 10px;
      cursor: pointer;
      line-height: 24px;
      border-right: 3px solid #ebeef5;
      &:hover {
        border-right-color: rgba(64, 158, 255, 0.6);
      }
      &.active {
        border-right-color: rgba(64, 158, 255, 1);
      }
    }
  }
  .floor-item {
    cursor: pointer;
    box-sizing: border-box;
    line-height: 24px;
    padding: 10px;
    border-right: 3px solid #ebeef5;
    &:hover {
      border-right-color: rgba(64, 158, 255, 0.6);
    }
    &.active {
      border-right-color: rgba(64, 158, 255, 1);
    }
    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .room-item {
    font-size: 14px;
    line-height: 20px;
    padding: 10px 15px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    margin-bottom: 10px;
    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .txt-red {
    color: #f56c6c;
  }
  .txt-green {
    color: #67c23a;
  }
  .bgno {
    background: #fef0f0;
  }
  .bgyes {
    background: #f0f9eb;
  }
}
</style>